import React from "react";
import {
    Box,
    Button,
    Chip,
    Skeleton,
    IconButton,
    Typography,
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
} from "@mui/icons-material";
import {useCardStyles} from "../../constants/styles";

const ItemsTable = (props) => {
    const {
        section,
        items,
        onCreateItem,
        onEditItem,
        onDeleteItem,
    } = props;
    const classes = useCardStyles();

    if (!section) return null;

    return (
        <Box className={classes.root}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h3" textAlign="left">
                    Элементы: {section.title}
                </Typography>
                <Button
                    size="small"
                    variant="contained"
                    onClick={onCreateItem}
                >Добавить элемент</Button>
            </Box>

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Код</TableCell>
                        <TableCell>Расшифровка</TableCell>
                        <TableCell>Год от</TableCell>
                        <TableCell>Год до</TableCell>
                        <TableCell align="right">Действия</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(items || []).map((item) => (
                        <TableRow key={`item-${item.id}`}>
                            <TableCell>
                                <Chip label={item.code} size="small" variant="outlined"/>
                            </TableCell>
                            <TableCell>{item.meaning}</TableCell>
                            <TableCell>{item.year_from || "—"}</TableCell>
                            <TableCell>{item.year_to || "—"}</TableCell>
                            <TableCell align="right">
                                <IconButton size="small" onClick={() => onEditItem(item)}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                                <IconButton size="small" color="error" onClick={() => onDeleteItem(item)}>
                                    <DeleteIcon fontSize="small"/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                    {(items || []).length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} align="center">
                                <Typography color="textSecondary" py={2}>Нет элементов</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Box>
    );
};

export default ItemsTable;
